<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Scanning MyKad
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    
    v-card-text.primary--text.py-16.text-center

      template(v-if="status === 'disconnected' || status === 'no_data'")
        v-avatar.mb-6(color="#FCE9E9" size=72)
          v-icon(size="36" color="#C82F2F") $yzi-alert-circle

        .h8.mb-1 No reader detected
        .text-xs.mb-8.neutral500--text Please make sure that your MyKad reader is connected and installed properly
        y-button(label="Retry" @click="retry" :loading="isLoading")

      template(v-else-if="status === 'card_removed'")
        v-avatar.mb-6(color="neutral200" size=72)
          v-icon.pa-5(color="neutral500") $yzi-image-user-x

        .h8.mb-1 No MyKad detected
        .text-xs.mb-8.neutral500--text Please make sure that the MyKad is placed and positioned properly in the MyKad reader
        y-button(label="Re-read MyKad" @click="retry" :loading="isLoading")

      template(v-else-if="status === 'success'")
        v-progress-circular.mb-10(width="4" size="84" color="#0D6EFF" indeterminate)
        .h8.mb-1 MyKad detected
        div Reading MyKad

      template(v-else)
        v-progress-circular.mb-10(width="4" size="84" color="#0D6EFF" indeterminate)
        .h8.mb-1 Reading MyKad

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    polling: null,
    cardData: null,
    status: null,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.startPolling()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchData () {
      this.isLoading = true
      this.$axios.get(`/clinics/${this.company.slug}/mykad_data`)
        .then(resp => {
          this.status = resp.data.status
          if (!this.status) {
            this.status = 'no_data'
            this.stopPolling()
          }
          if (this.status === 'card_removed' || this.status === 'disconnected') {
            this.stopPolling()
          }
          if (this.status === 'success') {
            this.startPolling()
            const data = resp.data
            if (data.type === 'MyKad') {
              if (data.photo) {
                this.cardData = data
                this.fetchPatient()
                this.stopPolling()
                this.clearCardData()
              }
            } else {
              this.cardData = data
              this.fetchPatient()
              this.stopPolling()
              this.clearCardData()
            }
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchPatient () {
      const params = {
       fields: 'id,name,phone,ic',
       ic: this.cardData.ic
      }
      this.$axios.get(`/clinics/${this.company.slug}/patients`, { params })
        .then(resp => {
          const data = resp.data.results.length > 0 ? resp.data.results[0] : this.cardData
          this.$emit('complete', data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
        })
    },
    startPolling () {
      this.stopPolling()
      this.polling = setInterval(() => {
        this.fetchData()
      }, 2000)
    },
    stopPolling () {
      clearInterval(this.polling)
    },
    clearCardData () {
      this.$axios.post(`/clinics/${this.company.slug}/mykad_data`, {
        status: 'card_read'
      })
    },
    retry () {
      this.fetchData()
    },
    closeDialog () {
      this.stopPolling()
      this.showDialog = false
    },
  },
  destroyed () {
    this.stopPolling()
  }
}
</script>